import AppSettings from "../AppSettings";
// Utils
import FormattersUtil from "./FormattersUtil";
import OfflineUtil from "./OfflineUtil";

const BACKEND_ENDPOINT = AppSettings.getBackendUrl();

export default class CachesUtil {
    static executeSpecialCacheChange = async (request, response, props) => {
        const indexedDB = OfflineUtil.getIndexedDb();

        if (`${BACKEND_ENDPOINT}events/` === FormattersUtil.getBaseURL(request.url)) {
            const guid = request.data?.id, id = response.data?.id;
            if (['POST', 'PUT'].includes(request.method)) {
                const guidIdList = [];
                if ((response.data && !isNaN(id)) || request.method === 'PUT') {
                    if (request.method === 'POST') await indexedDB.guidLinks.add({ guid, id, type: 'event' });
                    const usedId = request.method === 'POST' ? guid : id;
                    OfflineUtil.modifyDynamicCache(BACKEND_ENDPOINT + 'events/projectEvents/' + request.data.projectId, (body) => {
                        const elementIndex = body.findIndex(el => el.id === usedId);
                        let peString = JSON.stringify(body[elementIndex]);
                        if (guid && id) peString = peString.replaceAll(`"${guid}"`, id);
                        guidIdList.forEach(guidId => peString = peString.replaceAll(`"${guidId.guid}"`, guidId.id));
                        body[elementIndex] = JSON.parse(peString);
                        if (props.projectEvents?.length) {
                            const projectEvents = [...props.projectEvents];
                            const index = projectEvents.findIndex(pe => pe.id === usedId);
                            if (index !== -1) {
                                projectEvents[index] = body[elementIndex];
                                props.setProjectEvents(projectEvents);
                            }
                        }
                        return body;
                    });
                }
            }
        } else if (request.method === 'POST' && `${BACKEND_ENDPOINT}fileInfos/` === FormattersUtil.getBaseURL(request.url)) {
            const guid = request.data.get('id'); // On récupère l'id temporaire
            const id = response.data?.id; // On récupère l'ID réel généré par EF
            if (!isNaN(id)) {
                await indexedDB.guidLinks.add({ guid, id, type: 'fileInfo' });
                if (response.data.type === 'photo') {
                    const photosGalleries = [...props.photosGalleries];
                    const index = photosGalleries.findIndex(photo => photo.id === guid);
                    if (index !== -1) photosGalleries[index].id = response.data.id;
                    props.setPhotosGalleries(photosGalleries);
                } else if (response.data.type === 'file') {
                    const filesGalleries = [...props.filesGalleries];
                    const index = filesGalleries.findIndex(file => file.id === guid);
                    if (index !== -1) filesGalleries[index].id = response.data.id;
                    props.setFilesGalleries(filesGalleries);
                }
            }
        }
    }
}